import { useTranslation } from "react-i18next"
import { IconCheck, IconX } from "@tabler/icons"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { showNotification } from "@mantine/notifications"
import { postDelete } from "../../api/postDelete"
import { queries } from "../../lib/query-key-factory"

export const usePostDeleteMutation = () => {
  const queryClient = useQueryClient()
  const { t } = useTranslation()

  return useMutation(postDelete, {
    onSuccess: () => {
      showNotification({
        color: "green",
        icon: <IconCheck />,
        title: t("validation.post_deleted_success"),
        message: ""
      })

      queryClient.invalidateQueries(queries.posts._def)
    },
    onError: () => {
      showNotification({
        color: "red",
        icon: <IconX />,
        title: t("root.oops"),
        message: t("error.cant_finalize")
      })
    }
  })
}
